import React from 'react';
import {ClockCircleOutlined, TeamOutlined, UserOutlined} from "@ant-design/icons";
import RenderIf from "@/components/render-if";
import {Card, Space, Tag} from "antd";
import {formatDateFull} from "@/lib/utils/date";

function DeliverySmsHistory({record}) {
    return (
        <>
            <RenderIf condition={record?.data?.data?.meta?.notif?.length > 0}>

                {record?.data?.data?.meta?.notif?.map((item, index) => (
                    <Card
                        key={index}
                        type="inner"
                        size="small"
                        className="mb-3"
                        title={
                            <Space direction="vertical" size={0} className="w-full">
                                <div className="flex justify-between items-center w-full">
                                    <Space>
                                        <Tag color="blue">#{index + 1}</Tag>
                                        <span className="font-medium">{formatDateFull(item?.date)}</span>
                                    </Space>
                                    <Space>
                                        <Tag color="green">
                                            <UserOutlined /> {item?.count} نفر
                                        </Tag>

                                    </Space>
                                </div>
                            </Space>
                        }
                    >
                        {/* اطلاعات زمان‌بندی */}
                        {item?.schedule && (
                            <div className="mb-3 p-3 bg-blue-50 rounded-lg">
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                    <div>
                                        <div className="text-xs  ">ساعت شروع</div>
                                        <div className="font-medium">
                                            <ClockCircleOutlined className="mr-1" />
                                            {item.schedule.start_time}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="text-xs  ">ساعت پایان</div>
                                        <div className="font-medium">
                                            <ClockCircleOutlined className="mr-1" />
                                            {item.schedule.end_time}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="text-xs  ">فاصله زمانی</div>
                                        <div className="font-medium">
                                            <ClockCircleOutlined className="mr-1" />
                                            {item.schedule.interval_minutes} دقیقه
                                        </div>
                                    </div>
                                    <div>
                                        <div className="text-xs  ">تعداد در هر نوبت</div>
                                        <div className="font-medium">
                                            <TeamOutlined className="mr-1" />
                                            {item.schedule.recipient_count} نفر
                                        </div>
                                    </div>
                                </div>

                                {/* نمایش زمان‌های ارسال */}
                                {item.schedule.schedule_times && item.schedule.schedule_times.length > 0 && (
                                    <div className="mt-2 pt-2 border-t border-blue-200">
                                        <div className="text-xs   mb-1">نوبت‌ها:</div>
                                        <div className="flex flex-wrap gap-1">
                                            {item.schedule.schedule_times.map((time, idx) => (
                                                <Tag key={idx} color="blue" className="text-xs">
                                                    {time}
                                                </Tag>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* متن پیامک */}
                        <div className="mb-2">
                            <div className="text-xs   mb-1">متن پیامک:</div>
                            <div className="  p-3 rounded-lg whitespace-pre-wrap border dark:border-gray-600 border-gray-200">
                                {item?.notif_text}
                            </div>
                        </div>

                        {/* اطلاعات آماری */}
                        <div className="flex flex-wrap gap-3 text-xs  ">
                    <span>
                        <TeamOutlined className="mr-1" />
                        تعداد کل دریافت‌کنندگان: {item?.count} نفر
                    </span>
                            {item?.schedule?.number_of_rounds && (
                                <span>
                            <ClockCircleOutlined className="mr-1" />
                            تعداد نوبت‌های ارسال: {item.schedule.number_of_rounds} نوبت
                        </span>
                            )}
                        </div>
                    </Card>

                ))}
            </RenderIf>
        </>
    );
}

export default DeliverySmsHistory;